import { createSlice } from "@reduxjs/toolkit";

export const notificationsLangMapImages = createSlice({
  name: "notitifications_lang_map_images",
  initialState: {
    value: { status: false, data: [] },
  },
  reducers: {
    updateNotificationsLangMapImages: (state, action) => {
      state.value.status = true;
      state.value.data = action.payload;
    },
  },
});

export const { updateNotificationsLangMapImages } =
  notificationsLangMapImages.actions;

export default notificationsLangMapImages.reducer;
